
//axios call
const getList = (url,params) => {

    return axios.get(url,{params});    
};



export {getList}